// extracted by mini-css-extract-plugin
export default {"bookedFor":"tYNrsGIJIi1mQROCNzjV","bookedForSwitch":"B77MbT4VCB3Q2uHdiEtQ"};